module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATpJREFUOE+9lLFKBDEQhv9/l8tdqSjCrpaCbiH4CLaWvoCVD6CVhYX4BAraWlr7BKKtnaAYsJYsiOI1whE1I1lWXGFvze3JpZrAzJd/kn/C1GaClkuAu1zplWo5xwEC6BulpycHNEozpPtKV80K/x0oDjshChnhsMyb8B16hYyw708Xh4MynmpQ3axQIFcEVwsg5KaM64AOwACAHdc2ToCzXOnNYapHMraI7MWMLhzlHIK5Ako8RcKNR3V/XWyDJ0XwYLp6KX3PniGY+aWQeDEdPTsaEHIC8g2C3dp2HU5NT28FK4w78eKH/Twmse4HILXZK4CfBxMY09XzwUAPSezyJcG1WmD5UbQCVvxatVThyVbAIZYJBvb91OQ9fZQMsu2mWfc5TGx2S2ChKdG38hfsuz7o//PJoX79AiHAtvvGuL4uAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/merchant_gre.png
// module id = 0p4G
// module chunks = 2